import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BaseListComponent } from '../base-list/base-list.component';
import { RetailersService, RetailerNotificationRequest } from '../../backend/clients';
import { firstValueFrom } from 'rxjs';
import { TableSettingService } from '../../services/table.setting.service';
import { SessionService } from '../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailRegexValidator } from '../../validators/email.validator';
import { PermissionService } from '../../services/permission.service';

@Component({
    selector: 'dialog-pending-inventory',
    templateUrl: './dialog-pending-inventory.component.html',
    styleUrls: ['./dialog-pending-inventory.component.scss'],
    host: {
        class: 'dialog-pending-inventory'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class DialogInventoryPendingComponent extends BaseListComponent implements OnInit {

  private defaultTitle = 'MODALBOXES.INVENTORY_PENDING_TITLE';
  private emailTitle = 'MODALBOXES.INVENTORY_EMAIL_TITLE';
  displayEmailModalbox = false;

  @Input() title: string = this.defaultTitle;
  @Input() manual = false;

  @Output() onClose = new EventEmitter<boolean>();

  public reason: string = '';

  sendEmail = false;
  public emailForm: FormGroup = this.fb.group({
    id: [null],
    email: ['', [Validators.required, emailRegexValidator(), Validators.maxLength(50)]],
  });

  constructor(private confirmationService: ConfirmationService,
    public retailersService: RetailersService,
    public session: SessionService,
    private fb: FormBuilder,
    public permissionService: PermissionService,
    public override tableSettingService: TableSettingService,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.pageSize = 5;

    //const hasPermission = await this.permissionService.hasActionPermissions(Actions.retailer_inventories);
    const hasPermission = false;
    if (hasPermission) {
      const company = await this.session.getCompanyData();
      await this.tableSettingService.init();
      if (!this.manual && company.inventorySubmissionThresholdDays && company.inventorySubmissionThresholdDays > 0) {
        await this.get()
      }
    }
  }

  override async get() {
    this.session.setLoading(true);
    this.filter.pageNumber = this.pageNumber;
    this.filter.pageSize = this.pageSize;

    this.page = await firstValueFrom(this.retailersService.apiRetailersCheckInventoriesSubmissionPost(this.filter));

    this.data = this.page.results;

    this.session.setLoading(false);
    if (this.data?.length > 0 || this.manual) {
      this.show();
    }
  }

  public show() {
    this.confirmationService.confirm({
      key: 'inventory-dialog',
      header: ''
    });
  }

  onCancel() {
    this.confirmationService.close();
    this.onClose.emit(false);
  }

  async onSubmitEmailForm() {
    const payload: RetailerNotificationRequest = {
      email: this.emailForm.controls['email'].value
    };
    await firstValueFrom(this.retailersService.apiRetailersIdNotifyPost(this.emailForm.controls['id'].value, payload));
    this.onCancelEmailModal();
  }

  onCancelEmailModal() {
    this.displayEmailModalbox = false;
  }

  onOpenEmailModal(evt: any, data: any) {
    this.displayEmailModalbox = true;
    this.emailForm.patchValue({
      id: data.id,
      email: data.email
    });
  }
}
